// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1372":"f518d7be3db9f0bb","4223":"0ff299d2abfaa847","5890":"579d6e65455265fb","6012":"2265407dd342b45c","8893":"30aa06cf80817313","8966":"7b8e1a48bef531db","9194":"2ec740e63c9cc50a","9671":"8441b073b00f6181"}[chunkId] + ".js";
};